
































































import { deleteCourseSpec } from "@/api/course";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { solveLargeNumber } from "@/utils/common";
@Component
export default class extends Vue {
  @Prop() originData!: any[];
  @Prop() courseId!: number;
  priceTableData: any[] = [];
  blurStatus: boolean = true;
  created() {
    this.init();
  }
  @Watch("originData", { immediate: false, deep: false })
  onOriginChange(n: any[]) {
    this.init();
  }
  init() {
    if (this.originData.length > 0) {
      const arr: any[] = [];
      this.originData.map((item: any) => {
        arr.push({
          course_spec_id: item.course_spec_id,
          name: item.name,
          quantity: Number(item.quantity),
          unit_price: Number(item.unit_price),
          price: Number(item.price),
          join_combo: !!item.join_combo,
        });
      });
      this.priceTableData = arr;
    } else {
      this.priceTableData = [
        {
          name: "一个课时",
          quantity: 1,
          unit_price: 100,
          price: 100,
        },
      ];
    }
  }
  handleAddPrize() {
    const arr = this.priceTableData;
    arr.push({
      name: "一个课时",
      quantity: 1,
      unit_price: 100,
      price: 100,
    });
    this.priceTableData = arr;
  }
  handleDeletePrize(scope: any) {
    this.$confirm("确定删除？", `删除课时定价`, {
      confirmButtonText: "确定",
      confirmButtonClass: "mwow-button-filled success mini",
      cancelButtonText: "取消",
      cancelButtonClass: "mwow-button-filled mini",
      iconClass: "mwow-icon-error",
    })
      .then(() => {
        const index = scope.$index;
        const id = scope.row.course_spec_id;
        const arr = this.priceTableData;
        if (id) {
          deleteCourseSpec({
            course_id: this.courseId,
            course_spec_id: id,
          }).then((res: any) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              arr.splice(index, 1);
              this.priceTableData = arr;
            } else {
              this.$message({
                type: "error",
                message: "删除失败：" + res.message,
              });
            }
          });
        } else {
          arr.splice(index, 1);
          this.priceTableData = arr;
        }
      })
      .catch(() => {});
  }
  handleQuantityInput(scope: any) {
    scope.row.quantity = this.handleInput(scope.row.quantity);
  }
  handlePriceInput(scope: any) {
    scope.row.price = this.handleInput(scope.row.price);
  }
  // 输入逻辑控制
  handleInput(val: any) {
    let n = String(val);
    if (n.includes("-")) {
      this.$message({
        message: "不能为负数",
        type: "error",
      });
      let i = n.indexOf("-");
      n = n.slice(i + 1);
    }
    let l = n.split(".");
    // 如果有小数，并且小数的位数大于2，将2位之后的数直接截掉
    if (l.length > 1 && l[1].length > 2) {
      l[1] = l[1].slice(0, 2);
      this.$message({
        message: "最多输入两位小数",
        type: "error",
      });
    }
    return l.join(".");
  }
  // 获焦暂停计算
  handleFocus() {
    this.blurStatus = false;
  }
  // 失焦计算
  handleBlur() {
    this.blurStatus = true;
  }
  handleFloat(scope: any) {
    // 缓存上一次的值
    scope.row.val;
    if (this.blurStatus) {
      // 小数运算存在丢失精度的问题，先扩大两倍再进行运算，然后结果缩小两倍即可
      scope.row.val =
        solveLargeNumber(scope.row.price) /
        solveLargeNumber(scope.row.quantity);
    }
    return (solveLargeNumber(scope.row.val) / 100).toFixed(2);
  }
}
